/* The Performance stuff is still experimental on node, so shim it for now  */
var performance = typeof window !== 'undefined'
    ? window.performance
    : {
        now: function () { return Date.now(); },
    };
export default performance;
//# sourceMappingURL=performance.js.map